<!--
 * @Author: zouyaoji@https://github.com/zouyaoji
 * @Date: 2021-07-05 11:03:29
 * @LastEditTime: 2022-02-13 00:15:24
 * @LastEditors: zouyaoji
 * @Description:
 * @FilePath: \vue-cesium-starter\src\views\Home.vue

  :billboard="billboard"
  :position="{ lng: 108, lat: 32 }"
  :point="point"
  :label="label"
-->


<template>
 <el-row ref="viewerContainer" class="demo-viewer">
  <vc-viewer 
      :should-animate="true" 
      :scene3DOnly="true" 
      sceneMode=Cesium.SceneMode.SCENE3D,
      :vrButton= "false"
      :animation= "false"
      :baseLayerPicker= "false"
      :geocoder= "false"
      :timeline= "true"
      :fullscreenButton= "false"
      :homeButton= "false"                 
      :infoBox= "true"
      :navigationHelpButton= "false"
      :sceneModePicker= "false" 
      @ready="onViewerReady" 
      @leftClick="onMouseLeftClick"
      @rightClick="onMouseRightClick">

    <ProviderBaidu :defaultProvider="false"></ProviderBaidu>
    <ProviderAmap  :defaultProvider="true" ></ProviderAmap>
    <ProviderBing  :defaultProvider="false"></ProviderBing>
    <DisplayLEDHostOnMap></DisplayLEDHostOnMap>
    <vc-collection-point :points="pathPoints" ></vc-collection-point>
    <DynamicInspection></DynamicInspection>
    <!-- <LEDVcOverlayEcharts></LEDVcOverlayEcharts> -->
    <DynamicInspectionGLTF></DynamicInspectionGLTF>

<!-- <DynamicCloud></DynamicCloud> -->
    <vc-navigation ref="navig"></vc-navigation>
    <vc-measurements :offset="[0, 40]" :mainFabOpts="mainFabOpts"></vc-measurements>
    <!-- 添加绵仓雾灯路径 -->
    <vc-entity ref="ledRoad">
      <vc-graphics-polyline
        :positions="positions"
        :material="'blue'"
        :width="10"
      ></vc-graphics-polyline>
    </vc-entity>
    
  </vc-viewer>
  <!-- <select class="mapMenu" v-model="mapStyle" placeholder="请选择">
      <option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </option>
  </select> -->


  <ToolBar :controlLEDRoadShow="controlLEDRoadShow"></ToolBar>
  <MapProviderDialog ></MapProviderDialog>
  <!-- <PathEditor :mouseLeftClickPosition="mouseLeftClickPosition" :getPathPoints="getPathPoints"></PathEditor> -->
  <!-- <button class="addDynamicCloudBtn" @click="addDynamicCloud()">添加动态云层</button> -->
  <!--  v-show="isShowLEDHostList" -->
  <DisplayLEDHostList></DisplayLEDHostList>
  
  <VideoAbout></VideoAbout>
  <AddDeviceMore></AddDeviceMore>
  <AddDeviceSet></AddDeviceSet>

  <DisplaySystemInfos></DisplaySystemInfos>

  <EchartsAbout></EchartsAbout>
  <EchartsAreas :getProvinceName="getProvinceName"></EchartsAreas>
  <!-- <EZUIKitVideo></EZUIKitVideo> -->
  <!-- 跳转到about界面的按钮 -->
  <el-button class="aboutBtn" type="primary" round @click="gotoAbout">智慧城市</el-button>
</el-row>

</template>


<script>
import ProviderBaidu from '../components/ProviderBaidu.vue'
import ProviderAmap from '../components/ProviderAmap.vue'
import ProviderBing from '../components/ProviderBing.vue'
import ToolBar from '../components/ToolBar.vue'
import MapProviderDialog from '../components/MapProviderDialog.vue'
import DisplayLEDHostOnMap from '../components/DisplayLEDHostOnMap.vue'
import DynamicInspection from '../components/DynamicInspection.vue'
import PathEditor from '@/components/PathEditor.vue'
// import LEDVcOverlayEcharts from '../components/LEDVcOverlayEcharts.vue'
import DisplayLEDHostList from '../components/DisplayLEDHostList.vue'
// import DynamicCloud from '../components/DynamicCloud.vue'
import 'animate.css'
// import mianCangHighSpeedPath from '../assets/path.json' 

import VideoAbout from '../components/VideoAbout.vue'
// import EZUIKitVideo from '../components/EZUIKitVideo.vue'
// 飞机模型 巡检 组件
import DynamicInspectionGLTF from '../components/DynamicInspectionGLTF.vue'
import AddDeviceMore from '../components/AddDeviceMore.vue'
import AddDeviceSet from '../components/AddDeviceSet.vue'

// 系统消息 组件
import DisplaySystemInfos from '../components/DisplaySystemInfos.vue'
// echarts图标组件 1、led数据检测图 2、四川地图echarts
import EchartsAbout from '../components/EchartsAbout.vue'
import EchartsAreas from '../components/EchartsAreas.vue'

export default {
  name: 'Home',
  components:{ProviderBaidu,ProviderAmap,ProviderBing,ToolBar,
              MapProviderDialog,DisplayLEDHostOnMap,PathEditor,
              DynamicInspection,DisplayLEDHostList,
              VideoAbout,DynamicInspectionGLTF,AddDeviceMore,
              AddDeviceSet,DisplaySystemInfos,EchartsAbout,
              EchartsAreas},
  data () {
    return {
      Cesium:'',
      viewer:'',
      firstLoad:true,
      pathPoints:[{position:[112.96,28.19],color:'rgb(255,0,0)'}],
      mouseLeftClickPosition:{},
      mianCangHighSpeedPath:[],
      point: {
        pixelSize: 28,
        color: 'red'
      },
      label: {
        text: 'Hello VueCesium',
        pixelOffset: [0, 80],
        fillColor: 'red'
      },
      billboard: {
        image: 'https://zouyaoji.top/vue-cesium/favicon.png',
        scale: 0.5
      },
      mainFabOpts: {
        direction: 'right'
      },
      isShowDynamicCloud:false,
      dynamicCloudEntity:'',
      // isShowLEDHostList: false,
      positions:[],
      isShowLEDRoad:false ,
      borderProvince:'',  // 
    }
  },
  methods: {
    
    onViewerReady (e) {
      console.log('@@ e = ',e);
      console.log('onViewerReady')
      // console.log('home onViewerReady navig = ', this.$refs.navig);
      this.Cesium = e.Cesium ;
      this.viewer = e.viewer ;
      this.$bus.emit('getViewer',this.viewer);
      this.addPolyline();
      let handler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);
      handler.setInputAction((event)=>{
        
        let ray = this.viewer.camera.getPickRay(event.position);
        let cartesian = this.viewer.scene.globe.pick(ray, this.viewer.scene);
        let cartographic = Cesium.Cartographic.fromCartesian(cartesian);
        let lng = Cesium.Math.toDegrees(cartographic.longitude); // 经度
        let lat = Cesium.Math.toDegrees(cartographic.latitude); // 纬度
        let alt = cartographic.height; // 高度
        let coordinate = {
            longitude: Number(lng.toFixed(12)),
            latitude: Number(lat.toFixed(12)),
            altitude: Number(alt.toFixed(2))
        };
        console.log(coordinate);
        console.log('this=',this);
        this.mouseLeftClickPosition = coordinate ;
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK);  


      // 
      // 这是请求阿里DataV上的数据
      const jsonData = `/json/chinaBorder.json`;
      // jsonData一定要json文件

      console.log('home 组件=====，=== jsonData = ',jsonData);
      const geoJSON = Cesium.GeoJsonDataSource.load(jsonData, {
        stroke: Cesium.Color.fromCssColorString("#00fcff"),
        fill: Cesium.Color.fromCssColorString("#ffffff").withAlpha(0.0),
        strokeWidth: 10,
        markerSymbol: "?",
      });
      console.log('home 组件=====，=== geoJSON = ',geoJSON);
      const polyliner = this.viewer.dataSources.add(geoJSON);
      this.viewer.entities.add({
        polyliner:polyliner,
      })

    },
    onMouseLeftClick (e) {
      console.log('onMouseLeftClick = ',e)
        // this.mouseLeftClickPosition = e ;
    },
    onMouseRightClick(e){

      // 将屏幕坐标转换成经纬度，并将经纬度发送给 AddDeviceSet 组件
      let handler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);
      handler.setInputAction((event)=>{
        
        let ray = this.viewer.camera.getPickRay(event.position);
        let cartesian = this.viewer.scene.globe.pick(ray, this.viewer.scene);
        let cartographic = Cesium.Cartographic.fromCartesian(cartesian);
        let lng = Cesium.Math.toDegrees(cartographic.longitude); // 经度
        let lat = Cesium.Math.toDegrees(cartographic.latitude); // 纬度
        let alt = cartographic.height; // 高度
        let coordinate = {
            longitude: Number(lng.toFixed(12)),
            latitude: Number(lat.toFixed(12)),
            altitude: Number(alt.toFixed(2))
        };
        console.log(coordinate);
        console.log('this=',this);
        // 发送位置信号给 AddDeviceMore 组件
        this.$bus.emit('mouseRightClickCoordinate',coordinate);
      }, Cesium.ScreenSpaceEventType.RIGHT_CLICK);  
    },
    getPathPoints(posArray){
      console.log('posArray = ',posArray);

      this.pathPoints.splice(0,this.pathPoints.length);
      this.$nextTick(function(){
        posArray.forEach(element => {

          if(element.isSelected){
            this.pathPoints.push({ position: [element.lon , element.lat], color: 'rgb(255,0,0)' })
          }else{
            this.pathPoints.push({ position: [element.lon , element.lat], color: 'rgb(255,229,0)' })
          }   
        });
      })
    },
    addDynamicCloud(){
      let west = -180, east = 180
      // let entity ;
      if(!this.isShowDynamicCloud){
        this.isShowDynamicCloud = true;
        this.dynamicCloudEntity = this.viewer.entities.add({
            rectangle: {
                coordinates: new window.Cesium.CallbackProperty(() => {
                    west -= 1
                    east -= 1
                    return window.Cesium.Rectangle.fromDegrees(west, -90, east, 90)
                }),
                height: 400000,
                material: new window.Cesium.ImageMaterialProperty({
                    image: require("../assets/earth_cloud.png"),
                    transparent: true
                })
            }
        })
      }else{
        this.viewer.entities.remove(this.dynamicCloudEntity);
        this.isShowDynamicCloud = false;
      }      
    },
    addPolyline(){
      console.log('Home组件,addPolyline函数');
      window.Cesium.Resource.fetchJson('/path.json').then(
        (result)=>{
          let poss = [];
          console.log('Home组件,result = ',result)
          for (let i = 0; i < result.length; i++) {
            const data = result[i]
            poss.push([data.lon, data.lat]);
          }
          this.positions = poss ;
          // console.log('Home组件,positions = ',this.positions)         
        },
        error=>{
          console.log('Home组件,error = ',error.message);
        }
      )
    },
    controlLEDRoadShow(value){
      console.log('Home组件，controlLEDRoadShow 函数');
      if(value){
        this.$refs.ledRoad.unload();
      }else{
        this.$refs.ledRoad.reload();
      }
      // this.isShowLEDRoad = value ;
    },
    getProvinceName(params){
      console.log('home 组件,接收到 EchartsAreas 组件通过 props 属性发送的数据 params=',params.name);
      let list = [{name:'四川省',center:[104.065735,30.659462],url:"/json/sichuanBorder.json"},
                  {name:'江西省',center:[115.892151,28.676493],url:"/json/jiangxiBorder.json"},
                  {name:'天津市',center:[117.190182,39.125596],url:"/json/tianjinBorder.json"},
                  {name:'福建省',center:[119.306239,26.075302],url:"/json/fujianBorder.json"},];
      list.forEach(el=>{
        if(el.name == params.name){
          this.addBorderProvince(el.url);
          this.viewer.camera.flyTo({                        
              destination: Cesium.Cartesian3.fromDegrees(el.center[0],el.center[1], 18000000),
              orientation: {
                  heading: Cesium.Math.toRadians(0),
                  pitch: Cesium.Math.toRadians(-90),
                  roll: 0
              },
              // duration: 3 //3秒到达战场
          }); 
          
          setTimeout(()=>{
            this.viewer.camera.flyTo({                        
              destination: Cesium.Cartesian3.fromDegrees(el.center[0],el.center[1], 1500000),
              orientation: {
                  heading: Cesium.Math.toRadians(0),
                  pitch: Cesium.Math.toRadians(-90),
                  roll: 0
              },
              duration: 3 //3秒到达战场
            }); 
          },3000); 
        }
      });
    },
    addBorderProvince(url){
      // 清除之前绘制的省界线
      this.viewer.entities.remove(this.borderProvince);
      // this.viewer.dataSources.remove( this.geoJSON );
      // this.borderProvince.destroyed();
      // this.borderProvince = '';
      // 这是请求阿里DataV上的数据
      const jsonData = url;
      // jsonData一定要json文件
      
      console.log('home 组件，addBorderProvince = ',jsonData);
      const geoJSON = Cesium.GeoJsonDataSource.load(jsonData, {
        stroke: Cesium.Color.fromCssColorString("#ff0000"),
        fill: Cesium.Color.fromCssColorString("#ffffff").withAlpha(0.0),
        strokeWidth: 5,
        markerSymbol: "?",
      });
      console.log('home 组件=====，=== geoJSON = ', geoJSON);
      const polyliner = this.viewer.dataSources.add( geoJSON);
      this.borderProvince = this.viewer.entities.add({
        polyliner: polyliner,
      })
    },
    gotoAbout(){
      // 跳转到about界面
      window.location.replace('/city2.html');
    }
    // changeToAbout(){
    //   import(/* webpackChunkName: "about" */ './About');

    // }
    // showLEDHostList(isShow){
    //   this.isShowLEDHostList = isShow ;
    // },
  },
  mounted(){
    console.log("$bus= ",this.$bus);
    
    this.$bus.emit('getMapStyle','6');
    this.$bus.emit('getMapArray','高德地图');
    
    setTimeout(()=>{
      this.$bus.on('showDynamicCloud',this.addDynamicCloud);
      // this.$bus.on('showLEDHostList',this.showLEDHostList);
      this.$bus.emit('getLEDHostList');
      
    },5000);
    

      // fetch("../assets/path.json")
      //   .then((response) => {
      //     response.json()
      //     console.log('response = ',response.json());
      //   })
      //   .then((res) => {
      //     mianCangHighSpeedPath = res;
      //     console.log("mianCangHighSpeedPath = ",mianCangHighSpeedPath);
      //   });

      // axios.get('/path.json').then(
      //     response => {
      //         console.log('请求成功了 response = ',response.data)  
      //         this.mianCangHighSpeedPath = response.data ; 
      //         this.getPathPoints(this.mianCangHighSpeedPath); 
      //     },
      //     error => {
      //         console.log('请求失败了',error.message)
      //     }
      // )

  },
  unmounted(){
    this.$bus.all.clear();
  }
}
</script>
<style>

@import url("//unpkg.com/element-plus/dist/index.css");

@import url("//unpkg.com/vue-cesium/dist/index.css");

@import url("//unpkg.com/element-ui@2.15.14/lib/theme-chalk/index.css");
.viewer {
  /* height: 100vh; */
  height: 1080px;
}
#cesiumContainer{
  width: 1920px;
  height: 1080px;
}
.demo-viewer .el-row:last-child {
    margin-bottom: 0;
}

.demo-viewer .el-row {
    border-radius: 100px;
    align-items: baseline;
}

.demo-viewer  .demo-toolbar {
    position: absolute;

    /* transform: translate(-50%,-50%); */
    /* min-width: 185px;
    z-index: 100; */
    color: #fff;
    background-color: rgba(0,0,0,.9);
    border-radius: 5px;
}

.aboutBtn{
  position: absolute;
  top: 2%;
  left: 2%;
}
</style>
